import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import React from 'react'
import { useState } from 'react';

const ModalUpdate = (props) => {
  const [query,setQuery] = useState({

    name : props?.currentUser?.name,
    email : props?.currentUser?.email,
    role : props?.currentUser?.role
  });

  const handleInputChange = (target) => {

    const name = target.name;
    const value = target.value ;

    setQuery({...query,[name]:value });

  }


  return (
    <Modal
      show ={props?.show}
      onHide = {() => props?.onHide(null)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
        Update User
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="name">Name</Form.Label>
              <Form.Control 
              id="name" 
              placeholder="Name"
              name = "name"
              value = {query?.name}
              onChange = {(e) => handleInputChange(e.target)} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="name">Email</Form.Label>
              <Form.Control 
              id="name" 
              placeholder="Name"
              name = "email"
              value = {query?.email}
              onChange = {(e) => handleInputChange(e.target)}  />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="select">Disabled select menu</Form.Label>
              <Form.Select 
              disabled={false}
              name = "role"
              value = {query?.role}
              onChange = {(e) => handleInputChange(e.target)} >
                <option value="admin">Admin</option>
                <option value="member">Member</option>
              </Form.Select>
            </Form.Group>
            <Button 
            type="submit"
            onClick = {(e) => {
              e.preventDefault();
              props.handleUpdate(props.currentUser.id,query)
            }}
            >Update</Button>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => props?.onHide(null)}>Close</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalUpdate